<template>
  <el-card>
    <el-form ref="form" :model="user" label-width="80px">
      <el-form-item label="基本信息">
        <el-row :gutter="12">
          <el-card>
            <el-col :span="11">
              <div class="text item">
                姓名: {{ user.real_name }}
                <el-button v-if="hasPermsModfiy" type="primary" plain icon="el-icon-edit" size="mini" @click="showUpdateUserInfoDialog" />
              </div>
              <div class="text item">授权编号: {{ user.auth_code }}</div>
              <div class="text item">
                代理级别: {{ user.level_name }}
                <el-button
                  v-if="hasPermsUpgradeLevel"
                  type="primary"
                  plain
                  icon="el-icon-edit"
                  size="mini"
                  @click="showUpdateUserLevelDialog"
                />
              </div>
              <div class="text item">登录账号: {{ user.username }}</div>
              <div class="text item">
                所属区域:
                <span v-if="user.province">{{ user.province }}/{{ user.city }}/{{ user.district }}</span>
                <span v-else />
                <el-button v-if="hasPermsModfiy" type="primary" plain icon="el-icon-edit" size="mini" @click="showUpdateUserAreaDialog" />
              </div>
              <div class="text item">
                代理区域:
                <span v-if="user.agent_area_names" v-for="(agent, index) in user.agent_area_names" :key="index"
                  >{{ agent.province }}/{{ agent.city }}/{{ agent.district }}</span
                >
              </div>
            </el-col>
            <el-col :span="11">
              <div class="text item">微信号码: {{ user.wechat }}</div>
              <div class="text item">身份证号码: {{ user.idcard_no }}</div>
              <!-- <div class="text item">
                身份证照片:
                <file-preview v-if="user.idcard_photo" :file="user.idcard_photo" />
              </div> -->
            </el-col>
          </el-card>
        </el-row>
      </el-form-item>

      <el-form-item label="奖金余额">
        <el-row :gutter="12">
          <el-card>
            <el-col :span="11">
              <div class="text item">复销余额: ￥{{ user.total_balance }}</div>
              <div class="text item">
                奖金:￥{{ user.total_rebate }}
                <span style="color: #E6A23C;">（锁定中：￥ {{ user.locked_rebate }}）</span>
              </div>
            </el-col>
            <el-col :span="11">
              <div class="text item">报单余额: ￥{{ user.bill_balance }}</div>
              <div class="text item">临时奖金: ￥{{ user.temp_rebate }}</div>
            </el-col>
          </el-card>
        </el-row>
      </el-form-item>

      <el-form-item label="其他信息">
        <el-row :gutter="12">
          <el-card>
            <!-- <el-col :span="24">
              <div class="text item">上级代理: {{ user.parent_user ? user.parent_user.real_name : '' }}</div>
            </el-col> -->
            <!-- <el-col :span="24"><el-divider /></el-col>
            <el-col :span="24">
              <div class="text item">旗下代理总数: {{ getTotalCount(team_list) }}</div>
            </el-col>
            <el-col :span="11">
              <div class="text item">其中董事合伙人数量: {{ getLevelCount(team_list, 6) }}</div>
              <div class="text item">其中大区经理数量: {{ getLevelCount(team_list, 5) }}</div>
              <div class="text item">其中总代数量: {{ getLevelCount(team_list, 4) }}</div>
              <div class="text item">其中联创数量: {{ getLevelCount(team_list, 3) }}</div>
            </el-col>
            <el-col :span="11">
              <div class="text item">其中官方代理数量: {{ getLevelCount(team_list, 2) }}</div>
              <div class="text item">其中一级代理数量: {{ getLevelCount(team_list, 1) }}</div>
              <div class="text item">其中VIP代理数量: {{ getLevelCount(team_list, 0) }}</div>
            </el-col> -->
            <!-- <el-col :span="24"><el-divider /></el-col> -->
            <el-col :span="24">
              <div class="text item">该代理推荐代理总数量: {{ getTotalCount(direct_team_list) }}</div>
            </el-col>
            <el-col :span="11">
              <div class="text item">其中董事合伙人数量: {{ getDirectLevelCount(7) }}</div>
              <div class="text item">其中大区经理数量: {{ getDirectLevelCount(6) }}</div>
              <div class="text item">其中总代数量: {{ getDirectLevelCount(5) }}</div>
              <div class="text item">其中联创数量: {{ getDirectLevelCount(4) }}</div>
            </el-col>
            <el-col :span="11">
              <div class="text item">其中官方代理数量: {{ getDirectLevelCount(3) }}</div>
              <div class="text item">其中一级代理数量: {{ getDirectLevelCount(2) }}</div>
              <div class="text item">其中VIP代理数量: {{ getDirectLevelCount(1) }}</div>
            </el-col>
          </el-card>
        </el-row>
      </el-form-item>

      <el-form-item label="上级列表">
        <el-card>
          <el-table :data="user.relations" style="width: 100%" :default-sort="{ prop: 'depth', order: 'aesending' }">
            <el-table-column prop="depth">
              <template slot-scope="scope">
                <span>上{{ scope.row.depth }}级</span>
              </template>
            </el-table-column>
            <el-table-column prop="parent_user.level_name" label="等级" />
            <el-table-column prop="parent_user.real_name" label="姓名" />
            <el-table-column prop="parent_user.wx_nickname" label="昵称" />
          </el-table>
        </el-card>
      </el-form-item>
    </el-form>

    <el-dialog title="用户信息" :visible.sync="updateUserInfoDialog" width="400px" append-to-body>
      <lz-form
        style="width: auto;"
        label-width="80px"
        ref="userInfo"
        :submit="onUpdateUserInfo"
        :errors.sync="errors"
        :model="form"
        label-position="left"
        in-dialog
        disable-redirect
        disable-stay
      >
        <el-form-item label="姓名" required prop="real_name"><el-input v-model="form.real_name"/></el-form-item>
        <el-form-item label="微信号" required prop="wechat"><el-input v-model="form.wechat"/></el-form-item>
        <!-- <el-form-item label="手机号码" required prop="mobile"><el-input v-model="form.mobile"/></el-form-item> -->
        <el-form-item label="身份证号" required prop="idcard_no"><el-input v-model="form.idcard_no"/></el-form-item>
        <!-- <el-form-item label="身份证图" required prop="idcard_photo"><file-picker v-model="form.idcard_photo" ext="jpg,gif,png,jpeg" /></el-form-item> -->
      </lz-form>
    </el-dialog>

    <el-dialog title="修改等级" :visible.sync="updateUserLevelDialog" width="400px" append-to-body>
      <lz-form
        style="width: auto;"
        ref="levelForm"
        :submit="onUpdateUserLevel"
        :errors.sync="errors"
        :model="levelForm"
        label-position="top"
        in-dialog
        disable-redirect
        disable-stay
      >
        <el-form-item label="会员等级" required prop="level_id">
          <el-select v-model="levelForm.level_id" placeholder="请选择">
            <el-option v-for="item in levelList" :key="item.id" :label="item.level_name" :value="item.id" />
          </el-select>
        </el-form-item>
      </lz-form>
    </el-dialog>

    <el-dialog title="修改地址" :visible.sync="updateAddressDialog" width="400px" append-to-body>
      <lz-form
        style="width: auto;"
        ref="aeraForm"
        :submit="onUpdateAddress"
        :errors.sync="errors"
        :model="aeraForm"
        label-position="top"
        in-dialog
        disable-redirect
        disable-stay
      >
        <el-form-item label="所属地区" required prop="selCity"><city-cascader ref="cityCascader" v-model="aeraForm.selCity"/></el-form-item>
      </lz-form>
    </el-dialog>
  </el-card>
</template>

<script>
import LzForm from '@c/LzForm'
import FilePicker from '@c/FilePicker'
import FilePreview from '@c/FilePreview'
import FormHelper from '@c/LzForm/FormHelper'
import { getTeamCount, updateUser, upgradeLevel } from '@/api/users'
import { getLevelList } from '@/api/user-levels'
import CityCascader from '@c/CityCascader'
import { can } from '@/libs/utils'

export default {
  name: 'UserInfo',
  components: {
    LzForm,
    FilePicker,
    FilePreview,
    CityCascader,
  },
  props: {
    user: Object,
  },
  mixins: [FormHelper],
  data() {
    return {
      form: {
        real_name: this.user.real_name,
        wechat: this.user.wechat,
        mobile: this.user.mobile,
        idcard_no: this.user.idcard_no,
        // idcard_photo: this.user.idcard_photo,
      },
      levelForm: {
        level_id: '',
      },
      aeraForm: {
        selCity: [],
        province: '',
        provinceCode: 0,
        city: '',
        cityCode: 0,
        district: '',
        districtCode: 0,
      },
      team_list: [],
      direct_team_list: [],
      updateUserInfoDialog: false,
      updateUserLevelDialog: false,
      updateAddressDialog: false,
      errors: {},
      levelList: [],
      hasPermsModfiy: false,
      hasPermsUpgradeLevel: false,
    }
  },
  computed: {},
  created() {
    console.log('user::::', this.user)
    this.loadLevelList()
    this.getUserTeamCount()
    this.hasPermsModfiy = can('users.modfiy')
    this.hasPermsUpgradeLevel = can('users.upgrade-level')
  },
  methods: {
    async loadLevelList() {
      const { data } = await getLevelList()
      this.levelList = data
    },
    showUpdateUserInfoDialog() {
      this.fillAutoForm('form', 'form', this.user)
      this.updateUserInfoDialog = true
    },
    showUpdateUserLevelDialog() {
      this.fillAutoForm('levelForm', 'levelForm', this.user)
      this.updateUserLevelDialog = true
    },
    showUpdateUserAreaDialog() {
      this.fillAutoForm('aeraForm', 'aeraForm', this.user)
      this.aeraForm.selCity = [this.user.province_code, this.user.city_code, this.user.district_code]
      this.updateAddressDialog = true
    },
    async onUpdateUserInfo() {
      const { data } = await updateUser(this.resourceId, this.form)
      this.updateUserInfoDialog = false
      // 刷新用户信息
      this.$emit('refreshData')
    },
    async onUpdateUserLevel() {
      const { data } = await upgradeLevel(this.resourceId, this.levelForm)
      this.updateUserLevelDialog = false
      // 刷新用户信息
      this.$emit('refreshData')
    },
    async onUpdateAddress() {
      console.log(this.$refs['cityCascader'].$refs['CityCascader'].inputValue)
      if (this.aeraForm.selCity.length <= 0) {
        return false
      }
      const labels = this.$refs['cityCascader'].$refs['CityCascader'].inputValue
      const newLabels = labels.replace(/\s*/g, '')
      const cityLabels = newLabels.split('/')

      console.log(cityLabels)
      const selCityCode = this.aeraForm.selCity

      this.aeraForm.province = cityLabels[0]
      this.aeraForm.provinceCode = selCityCode[0]
      this.aeraForm.city = cityLabels[1]
      this.aeraForm.cityCode = selCityCode[1]
      this.aeraForm.district = cityLabels[2]
      this.aeraForm.districtCode = selCityCode[2]

      console.log(this.aeraForm)

      const { data } = await updateUser(this.resourceId, this.aeraForm)
      this.updateAddressDialog = false
      // 刷新用户信息
      this.$emit('refreshData')
    },
    getLevelCount(lists, levelId) {
      console.log(lists, levelId)
      if (lists == undefined) {
        return 0
      }
      const countItem = lists.filter(function(item, index) {
        return item.id === levelId
      })

      if (countItem.length > 0) {
        return countItem[0].userNum
      }

      return 0
    },
    getDirectLevelCount(levelId) {
      if (!this.direct_team_list || this.direct_team_list.length <= 0) {
        return 0
      }
      const countItem = this.direct_team_list.filter(function(item, index) {
        return item.id === levelId
      })

      if (countItem.length > 0) {
        return countItem[0].userNum
      }

      return 0
    },
    getTotalCount(lists) {
      if (lists == undefined || lists.length <= 0) {
        return 0
      }

      let total = 0

      lists.forEach(function(item, index) {
        total = total + item.userNum
      })

      return total
    },
    async getUserTeamCount() {
      const { data } = await getTeamCount(this.resourceId)
      this.team_list = data.team_list
      this.direct_team_list = data.direct_team_list
    },
  },
}
</script>

<style>
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 14px;
}
</style>
